import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.Employers'

export default defineMessages({
  Employers: {
    id: `${scope}.employers`,
    defaultMessage: 'Poslodavci',
  },
  EmployersSearch: {
    id: `${scope}.employersSearch`,
    defaultMessage: 'Pretraga kompanija',
  },
  Search: {
    id: `${scope}.search`,
    defaultMessage: 'Pretraga',
  },
  JobsCategory: {
    id: `${scope}.jobsCategory`,
    defaultMessage: 'Poslovi po kategorijama',
  },
  AllCategories: {
    id: `${scope}.allCategories`,
    defaultMessage: 'Sve kategorije',
  },
  ActiveJobs: {
    id: `${scope}.activeJobs`,
    defaultMessage: 'Aktivni poslovi poslodavca'
  },
  Job: {
    id: `${scope}.job`,
    defaultMessage: 'posao'
  },
});
